import { useEffect, useState } from 'react'
import { progressColor } from './progressColor'
import styles from './ProgressSlider.module.css'

/** Slider für den manuell gepflegten Fortschritt (keine Checkliste vorhanden) — feuert die
 * Mutation bewusst erst beim Loslassen/Blur statt bei jedem einzelnen Drag-Schritt, sonst
 * würde jede Mausbewegung eine eigene API-Anfrage auslösen. Der Track zeigt den Füllstand
 * direkt farbig an (dieselbe Rot-Gelb-Grün-Skala wie der Fortschrittsbalken). */
export function ProgressSlider({ value, onCommit, id }: { value: number; onCommit: (value: number) => void; id?: string }) {
  const [local, setLocal] = useState(value)

  useEffect(() => {
    setLocal(value)
  }, [value])

  const commit = () => {
    if (local !== value) onCommit(local)
  }

  return (
    <div className={styles.wrap}>
      <input
        id={id}
        type="range"
        min={0}
        max={100}
        value={local}
        onChange={(e) => setLocal(Number(e.target.value))}
        onMouseUp={commit}
        onTouchEnd={commit}
        onKeyUp={commit}
        onBlur={commit}
        className={styles.slider}
        style={{ background: `linear-gradient(to right, ${progressColor(local)} ${local}%, var(--surface-3) ${local}%)` }}
      />
      <span className={styles.value}>{local}%</span>
    </div>
  )
}
